export function saveReportDataStarted(state, payload) {
  return {
    saving: true,
    error: null,
  };
}

export function saveReportDataSuccess(state, payload) {
  if (state.reportType === "trend") {
    return {
      saving: false,
      trendDirty: false,
      error: null,
    };
  }
  return {
    saving: false,
    dirty: false,
    error: null,
  };
}

export function saveReportDataFailed(state, payload) {
  var message =
    payload && payload.error && payload.error.message
      ? payload.error.message
      : "Failed to save";
  return {
    saving: false,
    error: message,
  };
}
